// import store from '../store/index.js'

//获取服务器时间
export const headTime=(fn)=>{
    var xhr = new XMLHttpRequest()
    xhr.open('HEAD',location.href,true)
    xhr.onreadystatechange=function(){
        if( xhr.readyState == 4 && xhr.status == 200 ){
            var time = (xhr.getResponseHeader('Date'))
            var curDate = new Date(time)
            //window.console.log(time)
            var localTime = curDate.getTime()
            var localOffset=curDate.getTimezoneOffset()*60000//获得当地时间偏移的毫秒数
            var utc = localTime + localOffset//utc即GMT时间
            var offset =8//以夏威夷时间为例，东10区
            var hawaii = utc + (3600000*offset)
            curDate = new Date(hawaii)
            fn.call(this,curDate.getTime())
            //.toLocaleString()
            window.console.log(curDate.getTime(),'当前北京时间')
            window.console.log('服务器时间是：'+curDate.getFullYear()+'-'+(curDate.getMonth()+1)+'-'+curDate.getDate()+' '+curDate.getHours()+':'+curDate.getMinutes()+':'+curDate.getSeconds())
        }
    }
    xhr.send(null)
}

//URL
export const editHistoryUrl = (str) => {
    var url=window.location.href
    url=url.substring(0,url.lastIndexOf('/')+1)
    url=url+str
    window.history.pushState('','',url)
}

//金额格式化
export const toThousands = (num) => {
    return (num || 0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1,')
}

//获取当前时间, yyyy-mm-dd hh-mm-ss
export const getNow = () => {
    let date = new Date()
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
    let D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' '
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    let s = (date.getSeconds() < 10 ? '0'+ date.getSeconds() : date.getSeconds())
    let now = Y + M + D + h + m + s
    return now
}

export const randomString = (len) => {
    len = len || 6
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZ2345678'    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length
    var pwd = ''
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd + Date.now()
}

export const respHandle =  (resp) => {
    //请求错误
    if (!resp.ok ) {
        return -1
    }
    if (resp.status == '200') {
        //调用后端服务正常，获得返回结构体
        if (resp.body.status == '200') {
            return 0
        }
        //用户登录失效
        if (resp.body.status == '504') {
            let phone = storage.get('_phoneNo')
            store.init()
            if (phone == '' || phone == 'null' || !phone) {
                window.location.hash = '#!/hello'
                return 4
            }
            store.set({
                _phoneNo: phone
            })
            window.location.hash = '#!/login'
            return 3
        }
        //调用后端服务，系统异常
        return 1
    }
    //调用后端服务失败
    else {
        return 2
    }
}



// WEBPACK FOOTER //
// ./src/utils/tool.js